import React, { useContext, useMemo } from 'react'
import moment from 'moment'
import UpgradeRequiredPage from './UpgradeRequiredPage'
import { GlobalContext } from '../../App'
import { Box, Fade } from '@mui/material'
import { Outlet } from 'react-router-dom'
import UpgradeRequiredCard from './UpgradeRequiredCard'
import Loading from '../../pages/loading/loadingPage'

const SubscriptionGate = ({
  requiredTier = 3,
  featureName,
  caption,
  benefits,
  areNotIs,
  children,
  onGoBack,
  open,
  setOpen,
  inline,
  hideChildrenWhenBlocked = false,
}) => {
  const { tenantInfo, upgradeRequired, setUpgradeRequired } =
    useContext(GlobalContext)

  const accessState = useMemo(() => {
    if (!tenantInfo) return 'unknown'

    const inTrial =
      tenantInfo?.inInitialTrialPeriod &&
      tenantInfo?.trialEnd &&
      moment(tenantInfo.trialEnd).isAfter(moment())

    const sufficientTier =
      Number(tenantInfo?.subscriptionTier ?? 0) >= Number(requiredTier)

    return inTrial || sufficientTier ? 'allowed' : 'blocked'
  }, [tenantInfo, requiredTier])

  if (accessState === 'unknown') {
    return <Loading />
  }

  if (accessState === 'blocked') {
    if (inline || hideChildrenWhenBlocked) {
      return inline ? (
        <UpgradeRequiredCard
          requiredTier={requiredTier}
          benefits={benefits}
          caption={caption}
          featureName={featureName}
          areNotIs={areNotIs}
        />
      ) : (
        <UpgradeRequiredPage
          requiredTier={requiredTier}
          featureName={featureName}
          caption={caption}
          benefits={benefits}
          onGoBack={onGoBack}
          areNotIs={areNotIs}
        />
      )
    }

    return (
      <Box sx={{ position: 'relative' }}>
        <Box
          sx={{
            filter: accessState === 'blocked' ? 'blur(6px)' : 'none',
            transition: 'filter 0.45s ease',
            pointerEvents: accessState === 'blocked' ? 'none' : 'auto',
            userSelect: accessState === 'blocked' ? 'none' : 'auto',
          }}
        >
          {children || <Outlet />}
        </Box>

        <Fade in={accessState === 'blocked'} timeout={1200}>
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              zIndex: 20,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'center',
              p: 3,
              // background: 'rgba(15,23,42,0.08)',
              // backdropFilter: 'blur(2px)',
            }}
          >
            <UpgradeRequiredPage
              requiredTier={requiredTier}
              featureName={featureName}
              caption={caption}
              benefits={benefits}
              onGoBack={onGoBack}
              areNotIs={areNotIs}
            />
          </Box>
        </Fade>
      </Box>
    )
  }

  return children || <Outlet />
}

export default SubscriptionGate
